import Reflux from 'reflux';

const HistogramDataActions = Reflux.createActions({
  'load': {asyncResult: true},
});

export default HistogramDataActions;



// WEBPACK FOOTER //
// ../graylog2-server/graylog2-web-interface/src/actions/sources/HistogramDataActions.js